import React from 'react';
import cn from 'classnames';
import styles from './CellDataContainer.module.scss';

const CellDataContainer = ({ className, ...props }) => {
  return <div {...props} className={cn(styles.root, className)} />;
};

export default CellDataContainer;
